import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {connectModuleEnv} from '../../oe-module-env';
import {withIsOpenState, frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OENotification from '../../../lib/notification/oe-notification';
import OEAnimateHelper from '../../../lib/animation/oe-animate-helper';
import {OEViewType} from '../../../lib/oe-types';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEIconButton} from '../../elements/controls/oe-button';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export class OEInfoMessageViewStdUnconnected extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.connected = false;

        this.displayable = false;

        this.messages = [];

        this.state = {
            messages: []
        };

        this.onLanguageChanged = this.onLanguageChanged.bind(this);

        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    componentWillMount()    {
        this.onDisplayableChanged();
    }

    onConnect()  {
        this.connected = true;
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.updateDisplayable();
    }

    onRelease()    {
        this.connected = false;
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.updateDisplayable();
    }

    updateMessages()   {
        let si = this.oe.sharedInterface;

        //
        this.messages = [];
        while(true) {
            let message = si.getLocalizedStringRawEnc('info_message_' + OEToolbox.numberToString(this.messages.length + 1, 2));
            if(!message)    break;
            this.messages.push(message);
        }

        //
        if(this.messages.length) {
            this.setState({
                messages: this.messages
            });
        }

        //
        this.updateDisplayable();
    }

    updateDisplayable() {
        const displayable = !!(this.connected && this.messages.length);
        if(displayable == this.displayable) return;
        this.displayable = displayable;
        this.onDisplayableChanged();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateMessages();
    }

    onLanguageChanged() {
        this.updateMessages();
    }

    onDisplayableChanged()  {
        if(this.props.onDisplayableChanged)    this.props.onDisplayableChanged(this, this.displayable);
        if(this.props.controller && this.props.controller.onDisplayableChanged)    this.props.controller.onDisplayableChanged(this, this.displayable);
    }

    renderView()    {
        //
        let style = {left: this.props.offsets.left, transition: OEAnimateHelper.transitionForInsets(this.props.offsets.animate)};

        if(!this.props.isOpen)  {
            style.visibility = 'hidden';
            style.opacity = '0';
        }

        style.transition = style.transition + (style.transition.length ? ', ' : '') + 'visibility 0.333s ease-in-out, opacity 0.333s ease-in-out';

        //
        let messages = this.state.messages.map((message, index) => 
            <span key={index} className={'info-message-msg' + (index == 0 ? ' first' : '') + (index == this.state.messages.length - 1 ? ' last' : '')}>
                {message}
            </span>
        );

        //
        return (
            <div className="std-label-text-color info-message-view" style={style}>
                <div className="light-bg-border info-message-container">

                    {!this.props.onCloseBtnPressed && !(this.props.controller && this.props.controller.onCloseBtnPressed) ? null :
                        <OEIconButton
                            className="transparent-btn close-btn"
                            icon={OEIconCodes.infoMessageViewClose}
                            onPressed={this.onCloseBtnPressed}
                        />
                    }

                    {messages}

                </div>

                <div className="info-message-spacer"></div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                {this.renderView()}
            </React.Fragment>
        );
    }

    onCloseBtnPressed()    {
        if(this.props.onCloseBtnPressed)    this.props.onCloseBtnPressed(this);
        if(this.props.controller && this.props.controller.onCloseBtnPressed)    this.props.controller.onCloseBtnPressed(this);
    }
}

OEInfoMessageViewStdUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEInfoMessageViewStdUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool,
    onCloseBtnPressed:          PropTypes.func,
    onDisplayableChanged:       PropTypes.func,
    controller: PropTypes.shape({
        onCloseBtnPressed:      PropTypes.func,
        onDisplayableChanged:   PropTypes.func,
    })
};

export const OEInfoMessageViewStd = frefFromRef(connectModuleEnv((env) => {
    return {
        offsets: {
            left:               env.ui.leftSlideInContainer.offset,
            animate:            {left: env.ui.leftSlideInContainer.animate}
        }
    };
})(frefToRef(OEInfoMessageViewStdUnconnected)));

//
export class OEInfoMessageStdControllerUnconnected extends React.PureComponent {

    constructor(props) {
        super(props);

        //
        this.debugOutEnabled = false;

        //
        this.blockingViewTypes = [OEViewType.start, OEViewType.welcome, OEViewType.info, OEViewType.help, OEViewType.manual, OEViewType.screenshot, OEViewType.startSelection];

        //
        this.openTimeOut = 10000;
        this.closeTimeOut = -1;                 // for values < 0 the view will not get closed

        //
        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        //
        this.viewDisplayable = false;

        this.displayable = false;

        this.blocked = false;

        //
        this.shown = false;

        //
        this.onViewOpenStateChanged = this.onViewOpenStateChanged.bind(this);

        this.onOpenTimer = this.onOpenTimer.bind(this);
        this.onCloseTimer = this.onCloseTimer.bind(this);

        this.onViewDisplayableChanged = this.onViewDisplayableChanged.bind(this);
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    registerOnViewOpenStateChanged(props)    {
        props = props || this.props;

        this.unregisterOnViewOpenStateChanged(props);

        if(props.appComponent && props.appComponent.uiLayer) {
            props.appComponent.uiLayer.notificationCenter.register(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        }
    }

    unregisterOnViewOpenStateChanged(props)    {
        props = props || this.props;
        
        if(props.appComponent && props.appComponent.uiLayer) {
            props.appComponent.uiLayer.notificationCenter.unregister(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        }
    }

    componentDidMount()    {
        this.debugOut('Info Message - componentDidMount');
        this.mounted = true;
        this.tryOpen();
        this.registerOnViewOpenStateChanged();
    }

    componentWillUnmount()  {
        this.debugOut('Info Message - componentWillUnmount');
        this.unregisterOnViewOpenStateChanged();
        this.mounted = false;
        this.clearOpenTimer();
        this.clearCloseTimer();
    }

    componentWillReceiveProps(nextProps)   {

        if(this.props.isOpen != nextProps.isOpen)   {
            this.debugOut('Info Message - componentWillReceiveProps 1');

            if(nextProps.isOpen && this.shown && this.closeTimeOut >= 0)    {
                this.tryClose(nextProps, true);
            }
        }

        if(this.props.target != nextProps.target || this.props.appComponent != nextProps.appComponent || this.props.openState != nextProps.openState)   {
            this.debugOut('Info Message - componentWillReceiveProps 2');

            if(this.props.appComponent != nextProps.appComponent)   {
                this.unregisterOnViewOpenStateChanged();
                this.registerOnViewOpenStateChanged(nextProps);
            }

            this.updateDisplayable(nextProps);
            this.updateBlocked(nextProps);

            if(this.props.openState != nextProps.openState) {
                this.tryOpen(nextProps);
                if(nextProps.isOpen && this.shown && this.closeTimeOut >= 0)  this.tryClose(nextProps, true);
            }
        }
    }

    onConnect()  {
        this.debugOut('Info Message - onConnect');
        this.connected = true;
        this.updateDisplayable();
    }

    onRelease()    {
        this.debugOut('Info Message - onRelease');
        this.connected = false;
        this.updateDisplayable();
    }

    onViewOpenStateChanged(message, userInfo)    {
        if(!this.blockingViewTypes.includes(userInfo.type)) return;

        this.debugOut('Info Message - onViewOpenStateChanged - viewType: ' + userInfo.type);

        this.updateBlocked();
    }

    isDisplayable(props)    {
        props = props || this.props;
        if(!(this.connected && props.appComponent && props.openState && this.viewDisplayable))  return false;

        let si = this.oe.sharedInterface;
        let includeTargets = si.getLocalizedStringRawEnc('info_message_include_targets');
        let excludeTargets = si.getLocalizedStringRawEnc('info_message_exclude_targets');

        if(includeTargets)  {
            includeTargets = includeTargets.split(',').map(target => target.trim()).filter(target => target.length > 0);
            if(includeTargets.length && !includeTargets.includes(props.target))   return false;
        }

        if(excludeTargets)  {
            excludeTargets = excludeTargets.split(',').map(target => target.trim()).filter(target => target.length > 0);
            if(excludeTargets.length && excludeTargets.includes(props.target))   return false;
        }

        return true;
    }

    updateDisplayable(props)    {
        let displayable = this.isDisplayable(props);
        if(displayable == this.displayable) return;
        this.displayable = displayable;
        this.onDisplayableChanged();
    }

    isBlocked(props)    {
        props = props || this.props;

        let viewType = this.blockingViewTypes.find((type) => {
            let view = OEViewType.getRef(type, props.appComponent);
            return view && view.isOpen();
        });

        return !!viewType;
    }

    updateBlocked(props) {
        let blocked = this.isBlocked(props);
        if(blocked == this.blocked) return;
        this.blocked = blocked;
        this.onBlockedChanged();
    }

    onDisplayableChanged()  {
        this.debugOut('Info Message - onDisplayableChanged - ' + String(this.displayable));

        if(this.displayable) {
            this.tryOpen();
        } else {
            this.tryClose();
        }
    }

    onBlockedChanged()  {
        if(this.blocked) {
            this.clearOpenTimer();
        } else {
            this.tryOpen();
        }
    }

    startOpenTimer()    {
        this.clearOpenTimer();
        if(!this.mounted)   return;
        this.debugOut('Info Message - startOpenTimer');
        this.openTimer = setTimeout(this.onOpenTimer, this.openTimeOut);
    }

    clearOpenTimer()   {
        if(!this.openTimer)  return;
        this.debugOut('Info Message - clearOpenTimer');
        clearTimeout(this.openTimer);
        this.openTimer = null;
    }

    startCloseTimer()    {
        this.clearCloseTimer();
        if(!this.mounted || this.closeTimeOut < 0)   return;
        this.debugOut('Info Message - startCloseTimer');
        this.closeTimer = setTimeout(this.onCloseTimer, this.closeTimeOut);
    }

    clearCloseTimer()   {
        if(!this.closeTimer)  return;
        this.debugOut('Info Message - clearCloseTimer');
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
    }

    tryOpen(props)   {
        props = props || this.props;

        if(this.openTimer || !this.displayable || this.blocked || this.shown)    return;

        this.debugOut('Info Message - tryOpen');

        this.clearCloseTimer();

        if(props.isOpen)    return;

        this.startOpenTimer();
    }

    tryClose(props, delayed = false)   {
        props = props || this.props;

        if((this.closeTimer && delayed))    return;

        this.debugOut('Info Message - tryClose - delayed: ' + delayed);

        this.clearOpenTimer();

        if(!props.isOpen)   return;

        if(delayed && this.closeTimeOut > 0)    {
            this.startCloseTimer();
            return;
        }

        this.clearCloseTimer();

        if(props.openState)    props.openState.setOpen(false);
    }

    onOpenTimer()   {
        this.debugOut('Info Message - onOpenTimer');

        this.openTimer = null;

        if(!this.displayable || this.blocked) {
            if(this.displayable && !this.props.isOpen)   this.startOpenTimer();
            return;
        }

        this.shown = true;

        if(this.props.openState)    {
            this.debugOut('Info Message - onOpenTimer - setOpen: true');
            this.props.openState.setOpen(true);
        }
    }

    onCloseTimer()   {
        this.debugOut('Info Message - onCloseTimer');

        this.closeTimer = null;

        if(this.props.openState)    {
            this.debugOut('Info Message - onCloseTimer - setOpen: false');
            this.props.openState.setOpen(false);
        }
    }

    renderView()    {
        const controller = {
            onDisplayableChanged: this.onViewDisplayableChanged,
            onCloseBtnPressed: this.onCloseBtnPressed
        };

        if(this.props.renderView)   return this.props.renderView(this, controller);

        return (
            <OEInfoMessageViewStd
                moduleId={this.props.moduleId}
                isOpen={this.props.isOpen}
                controller={controller}
            />
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                {this.renderView()}
            </React.Fragment>
        );
    }

    onViewDisplayableChanged(sender, displayable)  {
        this.viewDisplayable = displayable;
        this.updateDisplayable();
    }

    onCloseBtnPressed() {
        this.clearCloseTimer();

        if(this.props.openState)    this.props.openState.setOpen(false);
    }

    debugOut(str)   {
        if(this.debugOutEnabled)   console.log(str);
    }
};

OEInfoMessageStdControllerUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEInfoMessageStdControllerUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    target:                     PropTypes.string,
    isOpen:                     PropTypes.bool,
    renderView:                 PropTypes.func
};

export const OEInfoMessageStdController = withIsOpenState(frefFromRef(connectAppEnv((env) => {
    return {
        target:                 env.config.target,
        appComponent:           env.component
    };
})(frefToRef(OEInfoMessageStdControllerUnconnected))));